<template>
    <div class="">
        <div v-bind:class="ContentBlockBaseProps.Class" v-bind:style="ContentBlockBaseProps.Style">
            <div :class="BlockProps.Shadow? 'shadow-sm mb-3' : ''" :style="{'background-color' : BlockProps.BGColor + ' !important'}">
                <div class="container" v-bind:style="ContainerPadding">
                    <div class="h2" v-bind:class="BlockProps.HeaderAlignCenter? 'text-center' : ''">
                        <omnieditor :iseditmode="iseditmode" editortype="tinymce" keyDown v-model="BlockProps.Leadin" tag-name="span" :init="EditorConfig" />&nbsp;<propertyiconeditor v-if="BlockProps.HeaderIcon.Show" :blockprops="BlockProps" :inline="true" v-model:icon="BlockProps.HeaderIcon" :prompt="'Header Icon (click to change)'"></propertyiconeditor>
                    </div>
                    <!-- List Timeline -->
                    <ul class="list-unstyled list-timeline list-py-3">
                        <template v-for="(step, index) in BlockProps.Steps">
                            <li class="list-timeline-item" v-bind:class="index % 2 != 0? 'ms-auto' : ''">
                                <!-- Card -->
                                <div class="card shadow-lg card-lg" :style="{'background-color' : BlockProps.CardBgColor + ' !important'}">
                                    <div class="card-body">
                                        <!-- Media -->
                                        <div class="d-flex">
                                            <div class="flex-shrink-0">
                                                <propertyiconeditor v-if="step.Icon.Show" :blockprops="BlockProps" :inline="true" v-model:icon="step.Icon" :prompt="'Step Icon (click to change)'"></propertyiconeditor>
                                            </div>
                                            <div class="flex-grow-1 ms-4">
                                                <h4 class="card-title"><span class="fs-2" :style="{'color' : BlockProps.SequenceColor+ ' !important'}">0{{index+1}}.</span> <omnieditor :iseditmode="iseditmode" editortype="tinymce" keyDown v-model="step.Title" tag-name="span" :init="EditorConfig" /></h4>
                                                <omnieditor :iseditmode="iseditmode" editortype="tinymce" keyDown v-model="step.Content" tag-name="p" class="card-text" :init="EditorConfig" />
                                            </div>
                                        </div>
                                        <!-- End Media -->
                                    </div>
                                </div>
                                <!-- End Card -->
                            </li>
                        </template>
                    </ul>
                    <!-- End List Timeline -->
                </div>
            </div>

        </div>

        <div v-if="iseditmode" style="z-index:300" class="modal" :id="'editor' + BlockProps.UId" tabindex="-1" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Options - <button @click="Store.copyElementToArray(BlockProps.Steps, Store.DefaultBlockProps['Steps'].Steps, 0, 6)" type="button" class="btn btn-xs btn-info"><i class="bi bi-plus"></i> Add Step</button> <small style="font-size:14px;color:darkgray">(current # of steps: {{BlockProps.Steps.length}} / 6 max)</small></h5>
                    </div>
                    <div class="modal-body">
                        <hr style="margin: 0px; margin-bottom:10px;" />
                        <propertybaseeditors :blockprops="BlockProps" :additionalcfg="AdditionalCfg"></propertybaseeditors>                       
                        <propertytogglededitor propertyname="HeaderAlignCenter" :blockprops="BlockProps" prompt="Center Header"></propertytogglededitor>
                        <propertytogglededitor propertyname="Show" :blockprops="BlockProps.HeaderIcon" prompt="Show Header Icon"></propertytogglededitor>
                        <div>
                            <div class="row" v-for="(step, stepIndex) in BlockProps.Steps">
                                <div class="col col-11 text">
                                    <div style="display:inline-block; width: 150px !important;height: 75px !important;">
                                        <propertytogglededitor propertyname="Show" :blockprops="step.Icon" prompt="Show Icon"></propertytogglededitor>
                                    </div>

                                    <i class="bi bi-chevron-double-right"></i>
                                    <button :disabled="BlockProps.Steps.length <= 1" @click="Store.deleteElementAtIndex(BlockProps.Steps, stepIndex)" type="button" style="margin-left:5px;" class="btn btn-sm btn-danger"><i class="bi bi-trash"></i> Delete Step</button>
                                </div>
                                <div class="col col-1 d-flex align-items-center justify-content-center">
                                    <div id="target">
                                        <div class="row" style="padding:2px;">
                                            <div v-if="stepIndex > 0" class="col col-12">
                                                <button @click="Store.shiftElement(BlockProps.Steps, stepIndex, 'left')" data-toggle="tooltip" data-bs-toggle="tooltip" title="Move Up" type="button" style="width: 25px;" class="btn btn-xs btn-light"><i class="bi bi-chevron-up"></i></button>
                                            </div>
                                        </div>
                                        <div class="row" style="padding:2px;">
                                            <div v-if="stepIndex < (BlockProps.Steps.length - 1)" class="col col-12">
                                                <button @click="Store.shiftElement(BlockProps.Steps, stepIndex, 'right')" data-toggle="tooltip" data-bs-toggle="tooltip" title="Move Down" type="button" style="width: 25px;" class="btn btn-xs btn-light"><i class="bi bi-chevron-down"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr style="margin-top: 5px; margin-bottom:5px;" />
                            </div>
                        </div>

                        <propertycoloreditor :propertyname="'SequenceColor'" :blockprops="BlockProps" :prompt="'Sequence Color'"></propertycoloreditor>
                        <propertycoloreditor :propertyname="'CardBgColor'" :blockprops="BlockProps" :prompt="'Card Background Color'"></propertycoloreditor>


                        <!--<button @click="UploadNewAssetBlockConfig" type="button" class="btn btn-sm btn-secondary">Upload</button>-->
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">Done</button>
                        <!--<button type="button" class="btn btn-sm btn-primary">Save changes</button>-->
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import EventHub from '/src/Util/EventHub.js';
    import ContentBlockBase from '/src/components/ContentCreator/ContentBlockBase.vue'
    import { computed, ref, nextTick } from 'vue'

    export default {
        inheritAttrs: false,
        name: 'Steps',
        mixins: [ContentBlockBase],
        props: [],
        components: {

        },
        computed:
        {           
        },
        data() {
            return {  
            };
        },
        methods:
        {          
            EditProperties: function () {
                var id = '#editor' + this.BlockProps.UId;
                var modalEl = document.querySelector(id);
                if (modalEl == null) {
                    return;
                }
                var modal = bootstrap.Modal.getOrCreateInstance(modalEl); // Returns a Bootstrap modal instance
                modal.show();
            },
            
        },

        setup(props, context)
        {             
            return {} // anything returned here will be available for the rest of the component
        },
        created()
        {           
            
        },
        beforeUnmount()
        {
            
        },
        mounted() {
            nextTick().then(() => {
         
            });
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>

